// test304
(304 && 0);
